import { ChanWarn, ViewTab, ViewTabsWrap } from './ProgramSetupSchedule.styled';

export type ProgramSetupView = 'table' | 'schedule';

interface ViewTabsProps {
  value: ProgramSetupView;
  onChange: (view: ProgramSetupView) => void;
}

/** Table | Schedule toggle for the Program Setup list. */
export const ViewTabs = ({ value, onChange }: ViewTabsProps) => (
  <ViewTabsWrap role="tablist">
    <ViewTab
      type="button"
      role="tab"
      aria-selected={value === 'table'}
      $on={value === 'table'}
      onClick={() => onChange('table')}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <path d="M3 10h18M9 10v10" />
      </svg>
      Table
    </ViewTab>
    <ViewTab
      type="button"
      role="tab"
      aria-selected={value === 'schedule'}
      $on={value === 'schedule'}
      onClick={() => onChange('schedule')}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="5" width="18" height="16" rx="2" />
        <path d="M3 10h18M8 3v4M16 3v4" />
        <path d="M7 14h4M13 17h4" />
      </svg>
      Schedule
    </ViewTab>
  </ViewTabsWrap>
);

interface ConflictWarningProps {
  count: number;
  label: string;
  onClick: () => void;
}

/** Red ! beside the channel/station picker when the selected one has overlapping programs. */
export const ConflictWarning = ({ count, label, onClick }: ConflictWarningProps) =>
  count > 0 ? (
    <ChanWarn
      type="button"
      onClick={onClick}
      title={`${count} overlapping program${count === 1 ? '' : 's'} on this ${label.toLowerCase()}`}
      aria-label={`This ${label.toLowerCase()} has overlapping programs`}
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.3" strokeLinecap="round">
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7.5v5.5M12 16.4v.6" />
      </svg>
    </ChanWarn>
  ) : null;
